import { formatDate } from '@frontend/date';
import { DateRange } from '../types';

const EMPTY_RANGE: DateRange = ['', ''];

/**
 * Formats a DateRange dates into the provided date format
 *
 * @param range - DateRange where index 0 is start date and index 1 is end date
 * @param format - Date format string to use for formatting. Defaults to 'YYYY-MM-DD'.
 * @returns A DateRange tuple [startDate, endDate] with formatted date strings, or ['', ''] if range is undefined
 *
 * @example
 * ```typescript
 * // Format with default YYYY-MM-DD format
 * formatRange(['01/01/2023', '12/31/2023'])
 * // Returns: ['2023-01-01', '2023-12-31']
 *
 * // Format with custom format
 * formatRange(['2023-01-01', '2023-12-31'], 'MM/DD/YYYY')
 * // Returns: ['01/01/2023', '12/31/2023']
 *
 * // Handle undefined input
 * formatRange(undefined)
 * // Returns: ['', '']
 *
 * // Handle incomplete range
 * formatRange(['2023-01-01'])
 * // Returns: ['2023-01-01', '']
 * ```
 */
export const formatRange = (range?: DateRange, format = 'YYYY-MM-DD'): DateRange =>
  range ? [formatDate(range?.[0], format), formatDate(range?.[1], format)] : EMPTY_RANGE;
